export const getOffset = (el) => {
  const rect = el?.getBoundingClientRect()
  const specialTopMarge = el?.closest('.section_content').classList.contains('special_top_marge') ? 180 : 0
  return {
    left: rect?.left + window.scrollX,
    top: rect?.top + window.scrollY - specialTopMarge
  }
}

export const decodeToHtml = (string) => {
  let returnVal = string
  if (typeof document !== 'undefined') {
    const div = document?.createElement('div')
    div.innerHTML = string
    returnVal = typeof div.textContent !== 'undefined' ? div.textContent : div.innerText
  }
  return returnVal
}

export const removeHtmlTag = (text) => {
  return decodeToHtml(text)?.replace(/<[^>]*>?/gm, '')
}
